/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PatchV2UsersPasswordResetsIdMutationRequest, PatchV2UsersPasswordResetsIdMutationResponse, PatchV2UsersPasswordResetsIdPathParams, PatchV2UsersPasswordResetsId422 } from "../../../types/PatchV2UsersPasswordResetsId.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPatchV2UsersPasswordResetsIdUrlClient({ id }: { id: PatchV2UsersPasswordResetsIdPathParams["id"] }) {
  const res = { method: 'PATCH', url: `/v2/users/password_resets/${id}` as const }
  return res
}

/**
 * @description Reset user password using the token received via email.
 * **Requirements:**
 * - Token must be valid and not expired (2 hour validity)
 * - Password and confirmation must match
 * **After successful reset:**
 * - Password is updated
 * - Token is cleared (one-time use)
 * - User can login with new password
 * @summary Reset password with token (V2)
 * {@link /v2/users/password_resets/:id}
 */
export async function patchV2UsersPasswordResetsIdClient({ id }: { id: PatchV2UsersPasswordResetsIdPathParams["id"] }, data: PatchV2UsersPasswordResetsIdMutationRequest, config: Partial<RequestConfig<PatchV2UsersPasswordResetsIdMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PatchV2UsersPasswordResetsIdMutationResponse, ResponseErrorConfig<PatchV2UsersPasswordResetsId422>, PatchV2UsersPasswordResetsIdMutationRequest>({ method : "PATCH", url : getPatchV2UsersPasswordResetsIdUrlClient({ id }).url.toString(), data : requestData, ... requestConfig })
  return res
}